import { createContext, useContext, useState } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper context type
export const PanZoomContext = createContext<any>(null)

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper props type
export const PanZoomProvider = ({ children, initialScale }: any) => {
  const [scale, setScale] = useState<number>(initialScale)

  const value = {
    scale,
    setScale,
  }

  return (
    <PanZoomContext.Provider value={value}>{children}</PanZoomContext.Provider>
  )
}

export const usePanZoomContext = () => {
  return useContext(PanZoomContext)
}
